import { GeneratedType } from "@cosmjs/proto-signing";
import { MsgUpdateParams } from "./types/cosmos/auth/v1beta1/tx";

const msgTypes: Array<[string, GeneratedType]>  = [
    ["/cosmos.auth.v1beta1.MsgUpdateParams", MsgUpdateParams],
    
];

export { msgTypes }